import { render } from "./custom_folder.vue?vue&type=template&id=d29cec00&lang=pug"
import script from "./custom_folder.vue?vue&type=script&lang=js"
export * from "./custom_folder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__